import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import { status_aktif } from "../../constants/general";
import qs from "qs";
import { FOTO_EVENT_HOST } from "../../constants/siteConfig";
import DropdownView from "./DropdownView";
import Cropper from "react-crop";
import "react-crop/cropper.css";

import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			mapel_id: "",
			question_text: "",
			question_id: "",
			keterangan: "",
			option: [],
			files: [],
			dataMapel : [],
			isButtonLoading: false,
			isLoading: false,
			option_count: "",
			question_type:"",
			option_match_text:"",
			defaultImg: "./noimage.gif",
			score:"0",
			imageCrop: null,
			event_foto: "",
			tags:[],
			setTags:[],
			editorState: EditorState.createEmpty(),
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeJumlah = this.handleChangeJumlah.bind(this);
		this.handleChangeScoreEssay = this.handleChangeScoreEssay.bind(this);
		this.handleChangeMapel = this.handleChangeMapel.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.addTags = this.addTags.bind(this);
		this.removeTags = this.removeTags.bind(this);
	}

	onEditorStateChange(editorState) {
		this.setState({
			question_text: draftToHtml(convertToRaw(editorState.getCurrentContent())),
			editorState: editorState
		});
	}

	addTags(event){
		let newState = [...this.state.tags];

		if (event.key === "Enter" && event.target.value !== "") {
			this.setState({
				tags: [...this.state.tags, event.target.value],
				keterangan: ''
			});
		}


	};

	removeTags(e){
		var array = [...this.state.tags]; // make a separate copy of the array
		var index = array.indexOf(e)
		if (index !== -1) {
			array.splice(index, 1);
			this.setState({tags: array});
		}
	};


	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" || target.type === "radio"  ? target.checked : target.value;
		
		const name = target.name;

		const newState = {
			[name]: value
		}

		if (name === "question_type") {
			newState.option_count = ""
		}

		this.setState(newState);
	}

	handleChangeJumlah(event) {
		const target = event.target;
		const value = target.type === "checkbox" || target.type === "radio"  ? target.checked : target.value;
		
		const name = target.name;

		if (this.props.mode === "Tambah") {
			if (this.state.question_type !== "essay") {
				if (this.state.question_type !== "match") {
					let newState = [];
					let newStateFile = [];

					for (var i = 0; i < value; i++) {
						newState.push({ option_text: "", score:"" });
					}

                    for (var i = 0; i < value; i++) {
                        newStateFile.push({ ind: i, file:"" });
                    }

					this.setState({ option: newState, files: newStateFile });
                }else{
					let newState = [];

					for (var i = 0; i < value; i++) {
						newState.push({ option_text: "",option_match_text: "", score:"" });
					}

					this.setState({ option: newState });
				}
				
			}
		}

		

		const newState = {
			[name]: value
		}

		if (name === "question_type") {
			newState.option_count = ""
		}

		this.setState(newState);
	}

	// handleSubmit() {
	// 	this.setState({ isButtonLoading: true });

	// 	const url =
	// 		this.props.mode === "Tambah" ? '/soal/add' : '/soal/edit/post';

	// 	const qOption = JSON.stringify(this.state.option);

	// 	let newState = {
			
	// 		question_type:this.state.question_type,
	// 		mapel_id: this.state.mapel_id,
	// 		question_text: this.state.question_text,
	// 	};

	// 	if (this.state.question_type !== 'essay') {
	// 		newState.option=qOption
	// 	}else{
	// 		newState.score=this.state.score
	// 	}



	// 	if (this.props.mode === "Edit") {
	// 		newState.question_id = this.props.match.params.question_id;
	// 	}

	// 	axios({
	// 		method: "post",
	// 		url: url,
	// 		data: qs.stringify(newState)
	// 	})

	// 	.then(response => {
	// 		const result = response.data;

	// 		if (result.success) {
	// 			Alert.success(result.message);
	// 			this.props.history.replace(
	// 				"/soal"
	// 			);
	// 		} else {
	// 			if (Array.isArray(result.message)) {
	// 				result.message.map(item => {
	// 					Alert.error(item);

	// 					return true;
	// 				});
	// 			} else {
	// 				Alert.error(result.message);
	// 			}

	// 			this.setState({ isButtonLoading: false });
	// 		}
	// 	})
		
	// 	.catch(error => {
	// 		console.log(error);
	// 		this.setState({ isButtonLoading: false });
	// 		Alert.error("Gagal terhubung ke server!");
	// 	});
	// }

	handleSubmit() {
		console.log(this.state.imageCrop);
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("question_id", this.state.question_id);
		formData.append("keterangan", this.state.tags.join("#"));
		formData.append("mapel_id", this.state.mapel_id);
		formData.append("question_type", this.state.question_type);
		formData.append("question_text", this.state.question_text);
		formData.append("event_foto", this.state.imageCrop);
		formData.append("user_id", localStorage.SISMART_USER_ID);
		

		const url = this.props.mode === "Tambah" ? "soal/add" : "soal/edit/post";

		this.setState({ isButtonLoading: true });

		axios
			.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/soal");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
	}

	

	handleChangeOptionText(event, index) {
		let newState = [...this.state.option];

		newState[index].option_text = event.target.value;

		this.setState({
			option: newState
		});
	}
	
	handleChangeGambar(index, file) {
		let newState = [...this.state.files];

		newState.push({ indeks: index, file: file })
		this.setState({
			files: newState
		});
	}

	onChange(evt) {
		this.setState({
			previewImg: null,
			defaultImg: null,
			imageCrop: null,
			image: evt.target.files[0],
			event_foto: ""
		});
	}

	async crop() {
		let image = await this.refs.crop.cropImage();

		this.setState({
			previewImg: window.URL.createObjectURL(image),
			defaultImg: null,
			event_foto: window.URL.createObjectURL(image),
			imageCrop: image
		});
	}

	imageLoaded(img) {
		if (
			img.naturalWidth && img.naturalWidth < 262 &&
			img.naturalHeight && img.naturalHeight < 147
		) {
			this.crop();
		}
	}

	clear() {
		this.refs.file.value = null;
		this.setState({
			previewImg: null,
			defaultImg: "./noimage.gif",
			image: null,
			imageCrop: null,
			event_foto: ""
		});
	}

    /*handleChangeOptionImage(event, index) {
		console.log(event.target.files);
        let file = [];
		let files = [];
        file[index] = event.target.files[0];

        this.setState({
            files: file
        });

        console.log(files);
	}*/

	handleChangeOptionMatchText(event, index) {
		let newState = [...this.state.option];

		newState[index].option_match_text = event.target.value;

		this.setState({
			option: newState
		});
	}

	handleChangeOptionScore(event, index) {
		let newState = [...this.state.option];
		newState[index].score = event.target.value;

		this.setState({
			option: newState
		});
	}

	handleChangeOptionTrue(event, index) {
		let newState = [...this.state.option];

		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;

		newState[index].score = value;

		this.setState({
			option: newState
		});
	}

	handleChangeScoreEssay(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	handleChangeMapel(event) {
		const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })
	}

	loadData() {
		if (this.props.mode === "Edit") {
			this.setState({ isLoading: true });

			const params = qs.stringify({
				question_id:this.props.match.params.question_id
	        })

			axios({
				method: "post",
				url: "/soal/edit?" + params
			})
			
			.then(response => {
				const result = response.data;

				if (result.success) {
					const contentBlock = htmlToDraft(result.data.question_text);

					if (contentBlock) {
						const contentState = ContentState.createFromBlockArray(
							contentBlock.contentBlocks
						);
						const editorState = EditorState.createWithContent(contentState);

						this.setState({
							editorState: editorState
						});
					}

					let newState = {
						question_id: result.data.question_id,
						question_text: result.data.question_text,
						keterangan: "",
						tags:result.data.keterangan ? result.data.keterangan.split('#') : [],
						mapel_id: result.data.mapel.mapel_id,
						question_pict: result.data.question_pict,
						question_type_pict: result.data.question_type_pict,
						question_type: result.data.question_type,
						option_count: result.data.question_type !== 'essay' ? result.data.option.length : "",

						previewImg:
							result.data.question_pict !== ""
								? "data:"+result.data.question_type_pict+";base64," + result.data.question_pict
								: null,
						defaultImg: result.data.question_pict !== "" ? null : "./noimage.gif"

					};
					if (result.data.question_type !== 'essay') {
						if (result.data.question_type !== 'match') {
							newState.option = result.data.option.map(
								(item, i) => ({
									option_id: item.option_id,
									option_text: item.option_text,
									score: item.score,
									option_pict: item.option_pict,
									type_pict: item.type_pict,
									
									previewImgs:
											item.option_pict !== ""
											? "data:"+item.type_pict+";base64," + item.option_pict
											: null,
											
								})
								
							);
						}else{
							newState.option = result.data.option.map(
								(item, i) => ({
									option_id: item.option_id,
									option_text: item.option_text,
									option_match_text: item.option_match_text,
									score: item.score
								})
							);
						}

					}else{
						newState.score=this.state.score
					}

					this.setState(newState);


				} else {
					Alert.error(result.message);
				}

				this.setState({ isLoading: false });
			})
			.catch(error => {
				console.log(error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isLoading: false });
			});
		}
	}

	loadDataMapel(){
        axios.post("/mapel")
        .then(response => {
            return response.data.mapelexport.map(item => ({
                key: item.mapel_id,
                value : item.mapel_nama
            }))
        })
        .then(result => {
            this.setState({
                dataMapel: result
            })
        })
        .catch(error => {
            console.log("Mapel Undefinded")
        })
    }

	componentDidMount() {
		this.loadData();
        this.loadDataMapel();

	}

	render() {
		return (
			
			<div className="col-sm-12">
				<div className="card" >
					<div className="card-header">{this.props.mode} Pertanyaan</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								<div className="form-group row">
									
									<div className="col-md-12">
										<DropdownView
											handleChange={this.handleChange}
											stateName="question_type"
											label="Type Soal"
											disabled={this.props.mode === 'Edit' ? true : false}
											items={[
												{ key: "single", value: "Single Option" },
												{ key: "essay", value: "Essay" }
											]}
											value={this.state.question_type}
										/>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Mata pelajaran
											</label>
											<div className="col-md-10">
			                                <FormDropdown
			                                    items = {this.state.dataMapel}
			                                    onChange = {this.handleChangeMapel}
			                                    value={this.state.mapel_id.toString()}
			                                    placeholder={"Pilih Mapel"}
			                                    name="mapel_id"
			                                />
			                                </div>
			                            </div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Pertanyaan
											</label>
											<div className="col-md-10">
												<Editor
													editorState={this.state.editorState}
													wrapperClassName="demo-wrapper"
													editorClassName="demo-editor"
													name="question_text"
													onEditorStateChange={this.onEditorStateChange.bind(
														this
													)}
													toolbar={{
														options: [
															"inline",
															"blockType",
															"fontSize",
															"fontFamily",
															"list",
															"textAlign",
															"history",
															"link",
															"embedded",
															"emoji"
														]
													}}
												/>

													<div className="col-md-5">
														<label className="btn btn-info" style={{ cursor: "pointer" }}>
															Choose Image ...
															<input
																ref="file"
																type="file"
																onChange={this.onChange.bind(this)}
																hidden
															/>
														</label>{" "}
														&nbsp;
														{this.state.previewImg && (
															<label onClick={this.clear.bind(this)} className="btn btn-danger" style={{ cursor: "pointer" }}>
																Clear
															</label>
														)}
														{this.state.defaultImg && (
															<div>
																<img
																	src={this.state.defaultImg}
																	className="img-thumbnail"
																	style={{ width: "320px", height: "180px" }}
																	alt=""
																/>
															</div>
														)}
														{this.state.previewImg && (
															<div>
																<img
																	src={this.state.previewImg}
																	className="img-thumbnail"
																	style={{ width: "320px", height: "180px" }}
																	alt=""
																/>
															</div>
														)}
														{this.state.image &&
															!this.state.previewImg && (
																<div>
																	<Cropper
																		ref="crop"
																		image={this.state.image}
																		width={800}
																		height={700}
																		onImageLoaded={this.imageLoaded.bind(this)}
																	/>
																	<button
																		onClick={this.crop.bind(this)}
																		className="btn btn-md btn-success"
																	>
																		Crop
																	</button>
																	&nbsp;
																	<button
																		onClick={this.clear.bind(this)}
																		className="btn btn-md btn-danger"
																	>
																		Clear
																	</button>
																</div>
															)}
													</div>

											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Tags
											</label>
											<div className="col-md-10">
												<input
													label="Tags Soal"
													name="keterangan"
													className="form-control"
													placeholder="Ketik tags/keterangan disini, Pisahkan dengan menekan enter "
													onChange={this.handleChange}
													onKeyUp={event =>this.addTags(event)}
													value={this.state.keterangan}
													style={{ marginBottom: 10 }}
												/>
												<div>
													{this.state.tags.map((tag, index) => (
														<div key={index} style={{ marginBottom:'5px' }}>
															<button className="btn btn-primary">{ tag }</button>
															{" "}
															<button style={{ border:'0px' }} className="btn-danger" onClick={(e)=>this.removeTags(tag)}><i className="fa fa-trash"></i></button>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>{" "}
						<button
							type="button"
							className="btn btn-md btn-danger"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={() => this.props.history.goBack()}
						>
							Batal
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Soal/Forms.js